import React from 'react'
import constant from '../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom';



const Layout = ({ title = '', titleLink = '', children, nonCardVersion = false }) => {
    return (
        <div className="page-content">
            <div className="container-fluid">
                {/* Start Page Title */}
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">

                            {titleLink ?  <h4 className="mb-sm-0 font-size-18"><Link to={titleLink}>{title}</Link></h4> :
                                <h4 className="mb-sm-0 font-size-18">{title}</h4>}
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="/">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active">{title}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Title */}

                {nonCardVersion ? (
                    children
                ) : (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Layout